@if (resourceUrl()) {
  <iframe
    [style.height]="full() ? '100%' : height() + 'px'"
    class="youtube_video"
    [src]="resourceUrl()"
    allowfullscreen
    frameborder="0"
  ></iframe>
}
